import React from "react";
export default function Loading(props){

    return(
        <div id={props.id} className="uk-width-1-1 uk-height-1-1 uk-text-center uk-padding">       
            <div className="uk-margin" uk-spinner="ratio: 5"></div>
            <p className="uk-text-meta">Buscando... Por favor, aguarde.</p>
       </div>       
    )
}